import React from 'react';
import { Video } from 'components/video/Video';

export const VideoSlice = ({
  tagline,
  title,
  embed,
  placeholder,
  isSlice,
  isSplitPage,
  isArticle,
}) => {
  return (
    <Video
      title={title}
      tagline={tagline}
      embed={embed}
      placeholder={placeholder}
      isSlice={isSlice}
      isSplitPage={isSplitPage}
      isArticle={isArticle}
    />
  );
};

export default VideoSlice;
